var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-80 0 871 871",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .logo {\n          fill: #666;\n        }\n    \n        @media (prefers-color-scheme: dark) {\n          .logo {\n            fill: #fff;\n          }\n        }\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logo",
    d: "m56.105 79.364c-.018 2.008 1.64 2.972 1.715 3.019-.933 1.365-2.385 1.552-2.903 1.574-1.235.125-2.411-.727-3.037-.727s-1.594.709-2.618.689c-1.348-.02-2.589-.783-3.283-1.989-1.399-2.427-.357-6.024 1.005-7.994.667-.963 1.461-2.048 2.505-2.008 1.006.04 1.386.65 2.6.65s1.556-.65 2.619-.631c1.081.021 1.767.984 2.429 1.95.764 1.118 1.08 2.2 1.098 2.257-.024.01-2.108.809-2.13 3.21",
    transform: "matrix(54.85 0 0 -54.85 -2485.383 4815.859)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "logo",
    d: "m482.4387 139.3374c30.3865-36.8044 50.9002-87.9802 45.2501-138.9887-43.7736 1.7571-96.7556 29.1808-128.1856 65.9852-28.1373 32.5275-52.8196 84.6335-46.131 134.6035 48.8183 3.7847 98.675-24.8497 129.0665-61.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.87a05d2e561a278d779ddb6ae6a4042e.svg";
export { ForwardRef as ReactComponent };